module.exports = StripeCheckout;